var productStars1 = 0;
var productStars2 = 0;
var productStars3 = 0;
var productStars4 = 0;
var productStars5 = 0;
var siteStars1 = 0;
var siteStars2 = 0;
var siteStars3 = 0;
var siteStars4 = 0;
var siteStars5 = 0;
var percent1 = 0;
var percent2 = 0;
var percent3 = 0;
var percent4 = 0;
var percent5 = 0;
var stars_weighted_average = 0;
var product_stars_total = 0;

function addStars(data) {
	productStars1 += parseInt(data.response.bottomline.star_distribution[1]);
	productStars2 += parseInt(data.response.bottomline.star_distribution[2]);
	productStars3 += parseInt(data.response.bottomline.star_distribution[3]);
	productStars4 += parseInt(data.response.bottomline.star_distribution[4]);
	productStars5 += parseInt(data.response.bottomline.star_distribution[5]);
}

// Adds the star values for the site to the variables in the ajax calls
function addSiteStars(data) {
	siteStars1 += parseInt(data.response.bottomline.star_distribution[1]);
	siteStars2 += parseInt(data.response.bottomline.star_distribution[2]);
	siteStars3 += parseInt(data.response.bottomline.star_distribution[3]);
	siteStars4 += parseInt(data.response.bottomline.star_distribution[4]);
	siteStars5 += parseInt(data.response.bottomline.star_distribution[5]);
}

function tallyReviews() {
	product_stars_total = productStars1 + productStars2 + productStars3 + productStars4 + productStars5;
	stars_weighted_average = (1 * productStars1 + 2 * productStars2 + 3 * productStars3 + 4 * productStars4 + 5 * productStars5) / product_stars_total;
	stars_weighted_average = stars_weighted_average.toFixed(1);

	percent1 = productStars1 / product_stars_total;
	percent2 = productStars2 / product_stars_total;
	percent3 = productStars3 / product_stars_total;
	percent4 = productStars4 / product_stars_total;
	percent5 = productStars5 / product_stars_total;

	percent1 = Math.ceil((percent1 * 100).toFixed(2));
	percent2 = Math.ceil((percent2 * 100).toFixed(2));
	percent3 = Math.ceil((percent3 * 100).toFixed(2));
	percent4 = Math.ceil((percent4 * 100).toFixed(2));
	percent5 = Math.ceil((percent5 * 100).toFixed(2));
}

function showDistribution() {
	var elm = $(".star-distribution");
	// Update average x.x out of 5 stars
	elm.find(".average").html(stars_weighted_average);

	// Update the bars and counts
	var row_5 = $("div.stars5");
	row_5.find(".bar .inner").css("width", percent5 + "%");
	row_5.find(".percent span").html(percent5);

	var row_4 = $("div.stars4");
	row_4.find(".bar .inner").css("width", percent4 + "%");
	row_4.find(".percent span").html(percent4);

	var row_3 = $("div.stars3");
	row_3.find(".bar .inner").css("width", percent3 + "%");
	row_3.find(".percent span").html(percent3);

	var row_2 = $("div.stars2");
	row_2.find(".bar .inner").css("width", percent2 + "%");
	row_2.find(".percent span").html(percent2);

	var row_1 = $("div.stars1");
	row_1.find(".bar .inner").css("width", percent1 + "%");
	row_1.find(".percent span").html(percent1);

	var childNode = document.querySelector(".star-wrapper");
	var parentNode = document.querySelector(".yotpo-bottomline-container-box");

	parentNode.appendChild(childNode);

	$(".star-wrapper").css("display", "grid");
}

//$(window).load(function(){
$.ajax({
	url: "https://api-cdn.yotpo.com/v1/widget/j7IWWReNDSsS2N49oY2UnUCFRz9qc1H0ZLRlRpiW/products/yotpo_site_reviews/reviews.json",
}).done(function (data) {
	addSiteStars(data);
});
$.when(
	$.ajax({
		url: "https://api-cdn.yotpo.com/v1/widget/j7IWWReNDSsS2N49oY2UnUCFRz9qc1H0ZLRlRpiW/products/6669751058594/reviews.json?per_page=1",
	}).done(function (data) {
		addStars(data);
	}),
	$.ajax({
		url: "https://api-cdn.yotpo.com/v1/widget/j7IWWReNDSsS2N49oY2UnUCFRz9qc1H0ZLRlRpiW/products/747875762233/reviews.json?per_page=1",
	}).done(function (data) {
		addStars(data);
	}),
	$.ajax({
		url: "https://api-cdn.yotpo.com/v1/widget/j7IWWReNDSsS2N49oY2UnUCFRz9qc1H0ZLRlRpiW/products/6964718731426/reviews.json?per_page=1",
	}).done(function (data) {
		addStars(data);
	}),
	$.ajax({
		url: "https://api-cdn.yotpo.com/v1/widget/j7IWWReNDSsS2N49oY2UnUCFRz9qc1H0ZLRlRpiW/products/5435170128034/reviews.json?per_page=1",
	}).done(function (data) {
		addStars(data);
	}),
	$.ajax({
		url: "https://api-cdn.yotpo.com/v1/widget/j7IWWReNDSsS2N49oY2UnUCFRz9qc1H0ZLRlRpiW/products/6669753155746/reviews.json?per_page=1",
	}).done(function (data) {
		addStars(data);
	}),
	$.ajax({
		url: "https://api-cdn.yotpo.com/v1/widget/j7IWWReNDSsS2N49oY2UnUCFRz9qc1H0ZLRlRpiW/products/1267082887225/reviews.json?per_page=1",
	}).done(function (data) {
		addStars(data);
	})
).done(function () {
	setTimeout(function () {
		tallyReviews();
	}, 10);
	setTimeout(function () {
		showDistribution();
	}, 200);
});
//});
